import { PickupAddressConstants } from '../store/pickupAddress.constants'

export const pickupAddressSchemas = [
  {
    inputKey: PickupAddressConstants.SET_LOCATION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LOCATION: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LOCATION'],
    errorMessage: {
      properties: {
        SET_LOCATION: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_ADDRESS_LINE1,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS_LINE1: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_LINE1'],
    errorMessage: {
      properties: {
        SET_ADDRESS_LINE1: 'Must be alphanumeric with max length of 255',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_ADDRESS_LINE2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,1000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_LINE2'],
    errorMessage: {
      properties: {
        SET_ADDRESS_LINE2: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_APT_SUITE_ROOM,
    isNumber: false,
    type: 'object',
    properties: {
      SET_APT_SUITE_ROOM: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,15}$',
      },
    },
    additionalProperties: false,
    required: ['SET_APT_SUITE_ROOM'],
    errorMessage: {
      properties: {
        SET_APT_SUITE_ROOM: 'Must be alphanumeric with max length of 15',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MILE_POST_MAJOR_ROADWAY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,35}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MILE_POST_MAJOR_ROADWAY'],
    errorMessage: {
      properties: {
        SET_MILE_POST_MAJOR_ROADWAY: 'Must be alphanumeric with max length of 35',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_CROSS_STREET_DIRECTIONS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CROSS_STREET_DIRECTIONS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CROSS_STREET_DIRECTIONS'],
    errorMessage: {
      properties: {
        SET_CROSS_STREET_DIRECTIONS: 'Must be alphanumeric with max length of 255',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_CITY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CITY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CITY'],
    errorMessage: {
      properties: {
        SET_CITY: 'Must be alphanumeric with max length of 150',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_ZIP,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ZIP: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_ZIP'],
    errorMessage: {
      properties: {
        SET_ZIP: 'Must be in the format: NNNNN or NNNNN-NNNN',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_CENSUS_TRACT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CENSUS_TRACT: {
        type: 'string',
        pattern: '^[0-9]{11}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CENSUS_TRACT'],
    errorMessage: {
      properties: {
        SET_CENSUS_TRACT: 'Must be an 11-digit number',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_COUNTY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COUNTY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COUNTY'],
    errorMessage: {
      properties: {
        SET_COUNTY: 'Must be alphanumeric with max length of 150',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_REFERRING_MD,
    isNumber: false,
    type: 'object',
    properties: {
      SET_REFERRING_MD: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_REFERRING_MD'],
    errorMessage: {
      properties: {
        SET_REFERRING_MD: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_REFERRING_MD_OTHER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_REFERRING_MD_OTHER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_REFERRING_MD_OTHER'],
    errorMessage: {
      properties: {
        SET_REFERRING_MD_OTHER: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_REFERRING_RN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_REFERRING_RN: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_REFERRING_RN'],
    errorMessage: {
      properties: {
        SET_REFERRING_RN: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_REFERRING_USNG,
    isNumber: false,
    type: 'object',
    properties: {
      SET_REFERRING_USNG: {
        type: 'string',
        pattern: '([1-9]|[1-5][0-9]|60)[C-HJ-NP-X][A-HJ-NP-Z][A-HJ-NP-V][0-9]{8}',
      },
    },
    additionalProperties: false,
    required: ['SET_REFERRING_USNG'],
    errorMessage: {
      properties: {
        SET_REFERRING_USNG: 'Must be in the format of USNG (e.g., 18SUJ2337106519).',
      },
    },
  },
  {
    inputKey: PickupAddressConstants.SET_RFT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RFT: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_RFT'],
    errorMessage: {
      properties: {
        SET_RFT: 'Must be alphanumeric with max length of 250',
      },
    },
  },
]
